// 🔥 CENTRALIZED ALARM CONFIGURATION (SCALABLE DCS STRUCTURE)


const alarmConfig = {
 
  


  
  // =====================================================
  // 🔵 CRUDE TANK
  // =====================================================


  LT_1301: {
    description: "CRUDE TANK V-1301 LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 3500,
      L: 7000,
      H: 63000,
      HH: 66500
    }
  },

  LT_1302: {
    description: "CRUDE TANK V-1302 LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 3500,
      L: 7000,
      H: 63000,
      HH: 66500
    }
  },


  LT_1303: {
    description: "CRUDE TANK V-1303 LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 3500,
      L: 7000,
      H: 63000,
      HH: 66500
    }
  },


  LT_1304: {
    description: "CRUDE TANK V-1304 LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 3500,
      L: 7000,
      H: 63000,
      HH: 66500
    }
  },


   // =====================================================
  // 🔵 BLENDING TANK
  // =====================================================

  LT_1401: {
    description: "CRUDE BLENDING TANK V-1401 LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 3500,
      L: 7000,
      H: 63000,
      HH: 66500
    }
  },


  LT_1402: {
    description: "CRUDE BLENDING TANK V-1402 LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 3500,
      L: 7000,
      H: 63000,
      HH: 66500
    }
  },



   // =====================================================
  // 🔵 DAY TANK
  // =====================================================

  LT_1501: {
    description: "DAY TANK V-1501 LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 3500,
      L: 7000,
      H: 63000,
      HH: 66500
    }
  },


  LT_1502: {
    description: "DAY TANK V-1502 LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 3500,
      L: 7000,
      H: 63000,
      HH: 66500
    }
  },



   // =====================================================
  // 🔵 SLOP TANK
  // =====================================================

  LT_1601: {
    description: "SLOP TANK V-1601 LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 1000,
      L: 2000,
      H: 18000,
      HH: 19000
    }
  },





   // =====================================================
  // 🔵 DESALTER VESSEL
  // =====================================================

  LT_201: {
    description: "DESALTER V-201A CRUDE LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 26.15,
      L: 52.3,
    }
  },

  LT_202: {
    description: "DESALTER V-201A WATER LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 26.15,
      L: 52.3,
      H: 470.7,
      HH: 496.85
    }
  },



  LT_301: {
    description: "DESALTER V-201B CRUDE LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 26.15,
      L: 52.3,
    }
  },

  LT_302: {
    description: "DESALTER V-201B WATER LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 26.15,
      L: 52.3,
      H: 470.7,
      HH: 496.85
    }
  },




   // =====================================================
  // 🔵 PREFLASH TOWER
  // =====================================================

  LT_16001: {
    description: "PREFLASH TOWER BOTTOM LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 25,
      L: 50,
      H: 450,
      HH: 475
    }
  },


  
   // =====================================================
  // 🔵 PREFLASH REFLUX DRUM
  // =====================================================

  LT_18001: {
    description: "PREFLASH REFLUX DRUM NAPHTHA LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 25,
      L: 50,
      H: 450,
      HH: 475
    }
  },


  LT_18002: {
    description: "PREFLASH REFLUX DRUM WATER LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 25,
      L: 50,
      H: 450,
      HH: 475
    }
  },



   // =====================================================
  // 🔵 MAIN FRACTIONATION TOWER (T-102)
  // =====================================================

  LT_2301: {
    description: "MAIN FRACTIONATION TOWER (T-102) LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 25,
      L: 50,
      H: 450,
      HH: 475
    }
  },


   // =====================================================
  // 🔵 DIESEL STRIPPER (T-103)
  // =====================================================

  LT_2401: {
    description: "DIESEL STRIPPER (T-103) LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 25,
      L: 50,
      H: 450,
      HH: 475
    }
  },



   // =====================================================
  // 🔵 KEROSENE STRIPPER (T-104)
  // =====================================================

  LT_2402: {
    description: "KEROSENE STRIPPER (T-104) LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 25,
      L: 50,
      H: 450,
      HH: 475
    }
  },




  
  
   // =====================================================
  // 🔵 MAIN FRACTIONATION TOWER (T-102) REFLUX DRUM
  // =====================================================

  LT_2601: {
    description: "MAIN FRACTIONATION TOWER (T-102) REFLUX DRUM NAPHTHA LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 25,
      L: 50,
      H: 450,
      HH: 475
    }
  },


  LT_2602: {
    description: "MAIN FRACTIONATION TOWER (T-102) REFLUX DRUM WATER LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 25,
      L: 50,
      H: 450,
      HH: 475
    }
  },

  
   // =====================================================
  // 🔵 SURGE TANK
  // =====================================================

  LT_2701: {
    description: "SURGE TANK NAPHTHA LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 25,
      L: 50,
      H: 450,
      HH: 475
    }
  },


  LT_2702: {
    description: "SURGE TANK WATER LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 25,
      L: 50,
      H: 450,
      HH: 475
    }
  },




  
   // =====================================================
  // 🔵 STABILIZER TOWER (T-301)
  // =====================================================

  LT_2801: {
    description: "STABILIZER TOWER (T-301) LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 25,
      L: 50,
      H: 450,
      HH: 475
    }
  },





  
   // =====================================================
  // 🔵 STABILIZER TOWER (T-301) REFLUX DRUM
  // =====================================================

  LT_2901: {
    description: "STABILIZER TOWER (T-301) REFLUX DRUM NAPHTHA LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 25,
      L: 50,
      H: 450,
      HH: 475
    }
  },


  LT_2902: {
    description: "STABILIZER TOWER (T-301) REFLUX DRUM WATER LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 25,
      L: 50,
      H: 450,
      HH: 475
    }
  },

  
   // =====================================================
  // 🔵 CORROSION INHIBITION TANK
  // =====================================================

  LT_3101: {
    description: "CORROSION INHIBITION MIXING TANK LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 5000,
      L: 10000,
      H: 90000,
      HH: 95000
    }
  },


  LT_3102: {
    description: "CORROSION INHIBITION TRANSFER TANK LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 7500,
      L: 15000,
      H: 135000,
      HH: 1425000
    }
  },





  // =====================================================
  // 🔵 FUEL GAS SYSTEM
  // =====================================================

  LT_3201: {
    description: "LOW PRESSURE GAS SEPARATOR LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 25,
      L: 50,
      H: 450,
      HH: 475
    }
  },


  LT_3202: {
    description: "HIGH PRESSURE GAS SEPARATOR LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 25,
      L: 50,
      H: 450,
      HH: 475
    }
  },





  
   // =====================================================
  // 🔵 RESIDUE STORAGE TANK
  // =====================================================

  LT_3401: {
    description: "RESIDUE STORAGE TANK V-401 LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 3250,
      L: 6500,
      H: 58500,
      HH: 61750
    }
  },


  LT_3402: {
    description: "RESIDUE STORAGE TANK V-402 LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 3250,
      L: 6500,
      H: 58500,
      HH: 61750
    }
  },

  
   // =====================================================
  // 🔵 NAPHTHA STORAGE TANK
  // =====================================================

  LT_3501: {
    description: "NAPHTHA STORAGE TANK V-303 LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 4750,
      L: 9500,
      H: 85500,
      HH: 90250
    }
  },


  LT_3502: {
    description: "NAPHTHA STORAGE TANK V-304 LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 4750,
      L: 9500,
      H: 85500,
      HH: 90250
    }
  },

  
   // =====================================================
  // 🔵 LPG STORAGE TANK
  // =====================================================

  LT_3801: {
    description: "LPG STORAGE TANK V-514A LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 1000,
      L: 2000,
      H: 18000,
      HH: 19000
    }
  },


  LT_3802: {
    description: "LPG STORAGE TANK V-514B LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 1000,
      L: 2000,
      H: 18000,
      HH: 19000
    }
  },




  
   // =====================================================
  // 🔵 DIESEL STORAGE TANK
  // =====================================================

  LT_3601: {
    description: "DIESEL STORAGE TANK V-306 LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 4750,
      L: 9500,
      H: 85500,
      HH: 90250
    }
  },


  LT_3602: {
    description: "DIESEL STORAGE TANK V-307 LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 4750,
      L: 9500,
      H: 85500,
      HH: 90250
    }
  },



  
   // =====================================================
  // 🔵 KEROSENE STORAGE TANK
  // =====================================================

  LT_3701: {
    description: "KEROSENE STORAGE TANK V-308 LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 1000,
      L: 2000,
      H: 18000,
      HH: 19000
    }
  },


  LT_3702: {
    description: "KEROSENE STORAGE TANK V-309 LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 1000,
      L: 2000,
      H: 18000,
      HH: 19000
    }
  },





  
   // =====================================================
  // 🔵 DESALINIATION SOFT WATER STORAGE TANK
  // =====================================================

  LT_3901: {
    description: "DESALINIATION SOFT WATER STORAGE TANK V-202 LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 1000,
      L: 2000,
      H: 18000,
      HH: 19000
    }
  },

  
   // =====================================================
  // 🔵 FLARE SYSTEM
  // =====================================================

  LT_4101: {
    description: "FLARE KNOCKOUT DRUM (KOD) LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 10000,
      L: 20000,
      H: 180000,
      HH: 190000
    }
  },

    TT_2105: {
      description: "FURNACE OUTLET TEMPERATURE FOR CRUDE LINE TRANSMITTER",
      unit: "°C",   
      fluid: "VAPOUR",
      ranges: {
        LL: 0.00,
        L: 30.02,
        H: 420,
        HH: 500
      }
    },

    PT_1001: {
      description: "PRESSURE OF CRUDE FROM MARINE CUSTODY TRANSFER PUMP TO TANK FARM TRANSMITTER",
      unit: "MPa",   
      fluid: "LIQUID",
      ranges: {
        LL: 0.00,
        L: 0.02,
        H: 3.5,
        HH: 6.0
      }
    },

    PT_1102: {
      description: "PRESSURE OF CRUDE FROM PIPELINE CUSTODY TRANSFER PUMP TO TANK FARM TRANSMITTER",
      unit: "MPa",   
      fluid: "LIQUID",
      ranges: {
        LL: 0.00,
        L: 0.02,
        H: 3.8,
        HH: 6.0
      }
    },

    PT_1201: {
      description: "PRESSURE OF CRUDE FROM TRUCKING CUSTODY TRANSFER PUMP TO TANK FARM TRANSMITTER",
      unit: "MPa",   
      fluid: "LIQUID",
      ranges: {
        LL: 0.00,
        L: 0.02,
        H: 3.8,
        HH: 6.0
      }
    },



};

export default alarmConfig;